import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  addEditData
} from "../../controllers/coupons/coupons";
import { fetchIpAddress } from "../../controllers/API";

import LoadingEffect from "../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        coupon,
        discount_type,
        discount
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      } 
      form.append("coupon", coupon);
      form.append("discount_type", discount_type);
      form.append("discount", discount);
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const params = {
          edit_id : _id ? _id : null,
          coupon: coupon,
          discount_type: discount_type,
          discount: discount
        }
        const options = {
          url: "coupons/addeditdata",
          postData: params,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated.",
            description: `Data updated Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/coupons/list");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    }finally{
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("coupon") || form.get("coupon") === "undefined" || form.get("coupon") === null) {
      notification.error({
        message: "Validation Error",
        description: "Coupon is required",
      });
      return false;
    }

    if (!form.get("discount_type") ||  form.get("discount_type") === "undefined" || form.get("discount_type") === null) {
      notification.error({
        message: "Validation Error",
        description: "Discount type is required",
      });
      return false;
    }
    if (!form.get("discount") ||  form.get("discount") === "undefined" || form.get("discount") === null) {
      notification.error({
        message: "Validation Error",
        description: "Discount is required",
      });
      return false;
    }
    return true;
  };


  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = `WaveCompliance || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Coupon`;
  }, [ADDEDITDATA]);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Coupon
            </h5>
          </div>
          <Link to="/coupons/list">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    <div className="form-group col-lg-12 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="coupon"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Coupon :{" "}
                      </label>
                      <input
                        title="Enter coupon."
                        placeholder="Enter coupon."
                        type="text"
                        name="coupon"
                        className="form-control store_input_field"
                        id="coupon"
                        value={ADDEDITDATA?.coupon}
                        onChange={handleChange}
                      />
                      {error.coupon ? (
                        <p style={{ color: "red" }}>
                          {error.coupon}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="discount_type"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Discount type :{" "}
                      </label>
                      <select
                        name="discount_type"
                        id="discount_type"
                        className="form-control categories_select_tg_enter_product"
                        onChange={handleChange}
                        value={ADDEDITDATA.discount_type || ""}
                      >
                        <option value="">Select discount type</option>
                        <option value="Percentage">Percentage</option>
                        <option value="Amount">Amount</option>
                      </select>
                      {error.discount_type ? (
                        <p style={{ color: "red" }}>
                          {error.discount_type}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="discount"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Discount :{" "}
                      </label>
                      <input
                        title="Enter discount."
                        placeholder="Enter discount."
                        type="number"
                        name="discount"
                        className="form-control store_input_field"
                        id="discount"
                        value={ADDEDITDATA?.discount}
                        onChange={handleChange}
                      />
                      {error.discount ? (
                        <p style={{ color: "red" }}>
                          {error.discount}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>                    
                  </div> 
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
